((app, ng) => {

    app.controller("addAccountController", addAccountController);

    function addAccountController(advisorApi, annuityAccountApi, carrierApi, carrierProductApi, custodianApi, figToaster, investmentAccountApi, investmentAccountTypeApi, lifeAccountApi, lineOfBusinessApi, longTermCareAccountApi, medicareAccountApi, $mdDialog, $scope, _states, taxQualificationApi) {
        const $ctrl = this;

        $ctrl.$onInit = () => {
            $ctrl.states = _states;

            lineOfBusinessApi.getLineOfBusinesses().then(response => {
                $ctrl.linesOfBusiness = response;
            });
            custodianApi.getCustodians().then(response => {
                $ctrl.custodians = response;
            });

            carrierApi.getCarriers().then(response => {
                $ctrl.carriers = response;
            });

            taxQualificationApi.getTaxQualifications().then(response => {
                $ctrl.taxQualifications = response;
            });

            investmentAccountTypeApi.getInvestmentAccountTypes().then(response => {
                $ctrl.investmentAccountTypes = response;
            });

            advisorApi.getAdvisors().then(response => {
                $ctrl.advisors = response;
            });
        };

        const close = (account) => {
            $mdDialog.hide(account);
        };

        const selectLOB = (lob) => {
            $ctrl.ui.lineOfBusiness = !!lob
                ? $ctrl.linesOfBusiness.find(row => row.IsActive && row.Name === lob)
                : null;
        };

        const getCarrierProducts = (carrierId) => {
            const hasProducts = !!$ctrl.products.find(product => product.CarrierId === carrierId);

            if (!hasProducts) {
                carrierProductApi.getProductsPerCarrier(carrierId).then(response => {
                    $ctrl.products = [...$ctrl.products, ...response];
                });
            }
        };

        const searchCarriers = (searchTerm) => {
            searchTerm = !!searchTerm ? searchTerm.toLowerCase() : "";
            var results = !!searchTerm
                ? _.filter($ctrl.carriers, function (row) {
                    if (row.Business && row.Business.Name && row.Business.Name.toLowerCase().indexOf(searchTerm) !== -1) return true;
                    return false;
                })
                : $ctrl.carriers;
            return results;
        };

        const searchProducts = (searchTerm) => {
            searchTerm = !!searchTerm ? searchTerm : "";
            var results = !!searchTerm
                ? _.filter($ctrl.products, function (row) {
                    if (row.Name && row.Name.toLowerCase().indexOf(searchTerm.toLowerCase()) !== -1) return true;
                    return false;
                })
                : $ctrl.products;

            if (!!searchTerm && !$ctrl.products.find(row => { if (row.Name) row.Name.toLowerCase() === searchTerm.toLowerCase(); })) results.push({
                Id: null,
                Name: searchTerm,
                LineOfBusinessId: $ctrl.ui.lineOfBusiness.Id,
                CarrierId: $ctrl.account.InsuranceAccount.CarrierId,
                IsActive: true
            });

            return results;
        };

        function _buildCarrierProduct(productName) {
            let result = !!productName && !!$ctrl.account.InsuranceAccount.CarrierId
                ? {
                    CarrierId: $ctrl.account.InsuranceAccount.CarrierId,
                    Carrier: $ctrl.account.InsuranceAccount.Carrier,
                    Name: productName,
                    Cusip: null, RightBridgeCusip: null, FirelightCusip: null,
                    LineOfBusinessId: $ctrl.ui.lineOfBusiness.Id,
                    IsActive: true,
                    LineOfBusiness: $ctrl.ui.lineOfBusiness,
                    StateList: []
                }
                : {};
            return result;
        }

        const addProduct = (productName) => {
            $ctrl.ui.savingProduct = true;
            !!productName && !$ctrl.account.InsuranceAccount.Product.Id
                ? carrierProductApi.create(_buildCarrierProduct(productName))
                    .then((response) => {
                        $ctrl.products.push(response);
                        $ctrl.account.InsuranceAccount.CarrierProductId = response.Id;
                        figToaster.showSimple('Product "' + response.Name + '" added successfully.', 'top');
                    })
                    .catch((error) => {
                        console.log("Error", error.data);
                        $ctrl.account.InsuranceAccount.Product = null;
                        figToaster.showError('Error. Try adding your product again.', 'top');
                    })
                    .finally(() => { $ctrl.ui.savingProduct = false; })
                : $ctrl.ui.savingProduct = false;
        };

        const addAccount = (account, accountType) => {
            $ctrl.ui.saving = true;

            const createAccount = {
                investment: (acc) => {
                    return investmentAccountApi.create(acc);
                },
                annuity: (acc) => {
                    return annuityAccountApi.create(acc);
                },
                life: (acc) => {
                    return lifeAccountApi.create(acc);
                },
                ltc: (acc) => {
                    return longTermCareAccountApi.create(acc);
                },
                medicare: (acc) => {
                    return medicareAccountApi.createMedicareAccount(acc);
                }
            };

            createAccount[accountType](account)
                .then(response => {
                    let evt = {
                        account: response,
                        type: `${accountType.toUpperCase()}_ACCOUNT_CREATED`
                    };
                    $ctrl.close(evt);
                    figToaster.showSimple('New account added successfully.', 'top');
                })
                .catch(error => {
                    console.log(error.data);
                    figToaster.showError('Error: Try adding the account again.', 'top');
                })
                .finally(() => {
                    $ctrl.ui.saving = false;
                });
        };

        const advisorSelected = () => {
            return $ctrl.account.InsuranceAccount && $ctrl.account.InsuranceAccount.Advisors && $ctrl.account.InsuranceAccount.Advisors.length === 0;
        };

        // When user chooses a new LOB, we want to clear the previously selected product & carrier, if any
        const clearCarrierProduct = () => {
            $scope.addAccount.selectProduct.$setUntouched();
            $scope.addAccount.selectProduct.$setPristine();
            $ctrl.account.InsuranceAccount.Product = null;

            $scope.addAccount.selectCarrier.$setUntouched();
            $scope.addAccount.selectCarrier.$setPristine();
            $ctrl.account.InsuranceAccount.Carrier = null;
        };

        $ctrl.navigateBack = () => {
            $ctrl.ui.currIndex = $ctrl.ui.currIndex - 1;
            clearCarrierProduct();
        };

        ng.extend($ctrl,
            {
                ui: {
                    currIndex: 0,
                    lineOfBusiness: null,
                    savingProduct: false
                },
                addAccount,
                addProduct,
                advisorSelected,
                close,
                getCarrierProducts,
                linesOfBusiness: [],
                products: [],
                searchCarriers,
                searchProducts,
                searchTextCarrier: '',
                searchTextProduct: '',
                selectLOB
            });
    }

})(window.app, window.angular); //jshint: ignore:line